import { AsrResult, LastAsrResult } from './clientVoice.types';

export const enum ClientVoiceActionType {
    SetClientVoiceInitialized = 'CLIENT_VOICE/SET_INITIALIZED',

    AmendLastAsrResult = 'CLIENT_VOICE/AMEND_LAST_ASR_RESULT',
    CommitLastAsrResult = 'CLIENT_VOICE/COMMIT_LAST_ASR_RESULT',
    RollbackLastAsrResult = 'CLIENT_VOICE/ROLLBACK_LAST_ASR_RESULT',
}

export type SetClientVoiceInitializedAction = ReturnType<typeof setClientVoiceInitialized>;
export const setClientVoiceInitialized = () => ({
    type: ClientVoiceActionType.SetClientVoiceInitialized,
});

export type AmendLastAsrResultAction = ReturnType<typeof amendLastAsrResult>;
export const amendLastAsrResult = (payload: LastAsrResult | null) => ({
    type: ClientVoiceActionType.AmendLastAsrResult,
    payload,
});

export type CommitLastAsrResultAction = ReturnType<typeof commitLastAsrResult>;
export const commitLastAsrResult = (payload: AsrResult) => ({
    type: ClientVoiceActionType.CommitLastAsrResult,
    payload,
});

export type RollbackLastAsrResultAction = ReturnType<typeof rollbackLastAsrResult>;
export const rollbackLastAsrResult = () => ({
    type: ClientVoiceActionType.RollbackLastAsrResult,
    payload: null,
});
